import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, Header, Button, Text } from '@gasbuddy/react-components';
import AvailabilityForm from '../AvailabilityForm';

export default function UpdateAvailabilityModal({
  link,
  fluid,
  stationId,
  includeDiesel,
}) {
  const [shouldShowModal, setShouldShowModal] = useState(false);

  const handleShowModal = useCallback(() => {
    setShouldShowModal(true);
  }, []);

  const handleUpdateComplete = useCallback(() => {
    setShouldShowModal(false);
  }, []);

  return (
    <React.Fragment>
      <Modal
        size="sm"
        content={() => (
          <React.Fragment>
            <Header as="h3">Update Station</Header>
            <AvailabilityForm
              stationId={stationId}
              onComplete={handleUpdateComplete}
              includeDiesel={includeDiesel}
            />
          </React.Fragment>
        )}
        forceIsShowing={shouldShowModal}
      />
      {link
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        ? <Text as="a" onClick={handleShowModal}>Update</Text>
        : <Button size="sm" type="button" primary onClick={handleShowModal} fluid={fluid} uppercase>Update</Button>
      }
    </React.Fragment>
  );
}

UpdateAvailabilityModal.propTypes = {
  stationId: PropTypes.number.isRequired,
  includeDiesel: PropTypes.bool,
  link: PropTypes.bool,
  fluid: PropTypes.bool,
};

UpdateAvailabilityModal.defaultProps = {
  includeDiesel: false,
  link: false,
  fluid: false,
};
